<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <b-card>
            <div class="row">
              <div class="col-md-12 text-center">
                <h2 class="align-items-center">Berikut Adalah Kode Registrasi Anda:</h2>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-12 text-center">
                <h2 class="align-items-center" style="font-family: 'Verdana';"> {{ kodeRegis.kd_regis }} </h2>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-12 text-center">
                <h6 class="align-items-center">Silahkan tunjukan kode diatas kepada petugas Bea dan Cukai di Terminal Kedatangan Anda</h6>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      kodeRegis: ''
    }
  },
  methods: {
    getKode () {
      this.$http.get('getKode/' + this.$route.params.id)
        .then(response => {
          this.kodeRegis = response.data
        })
    }
  },
  created () {
    this.getKode()
  }
}
</script>


// WEBPACK FOOTER //
// src/views/transit/ResultTransit.vue?77a4dc42